<template>
  <div class="SerialAssigned">
    <ATable
      ref="table"
      v-loading="loading"
      min-height="200px"
      max-height="758px"
      :data="items"
      :placeholder="placeholder"
      :search_field="search_field"
      hide-button-insert
      hide-pagination
      border
      @cell-click="handleCellClick"
      @selection-change="handleSelectionChange"
    >
      <div slot="search">
        <div class="inline">할당일</div>
        <div class="inline ml-default">
          <APeriodSelector 
            ref="period" 
            @change="handleChangePeriod" 
          />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
          >검색(F5)</el-button>
        </div>
      </div>
      <el-table-column 
        type="selection" 
        align="center"
        :width="$width.selection"
      />
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"            
        :width="$width.indexw"
      />
      <el-table-column
        prop="contract_code"
        width="100"
        label="수주번호"
      />
      <el-table-column
        prop="customer_name"
        label="업체명"
        show-overflow-tooltip 
      />
      <el-table-column
        prop="good_code"
        width="150"
        label="기계품번"
      />
      <el-table-column
        prop="good_name"
        width="150"
        label="기계명"
        show-overflow-tooltip 
      />
      <el-table-column
        prop="code"
        width="120"        
        label="관리품번"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id !== editingId">
            {{scope.row.code}}
          </div>
          <div v-else>
            <el-input
              size="mini"
              v-model="scope.row.code"
              @keyup.native.enter="handleEnterCode(scope.row)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="product_name"
        width="150"
        label="관리품명"
        show-overflow-tooltip 
      />
      <el-table-column
        prop="assigned_date"        
        label="할당일"
        :width="$width.date"
      />
      <el-table-column
        prop="inbound_date"        
        label="입고일"
        :width="$width.date"
      />
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <div slot="buttons">
        <el-button
          :disabled="selection.length < 1"
          @click="handleClickPrint"
        >{{$t('title.serial_print')}}</el-button>
      </div>
    </ATable>
    <el-dialog      
      custom-class="form-dialog"
      top="0"
      width="450px"
      destroyOnClose
      :title="$t('title.serial_print')"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
    >
      <SerialSelectPrint
        v-if="dialog_visible"
        :items="selection"
        @completed="handleCompletedPrint"
      />
    </el-dialog>
  </div>
</template>
<script>
import SerialSelectPrint from "./SerialSelectPrint";

export default {
  name: "SerialAssigned",
  components: {SerialSelectPrint},
  data() {
    return {
      title: this.$t("title.serial"),
      loading: false,
      items: [],
      placeholder: '업체명, 기계코드, 기계명, 관리코드, 관리품명',
      search_field: ["customer_name", "good_code", "good_name", "code", "product_name"],
      period: {},
      editingId: -1,
      oldItem: null,
      selection: [],
      dialog_visible: false,
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listSerialAssigned(this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    calcelEditing() {
      if (this.editingId < 1) { return; }
      let index = this.items.findIndex(i => i.id === this.editingId);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    handleChangePeriod(value) {
      this.period = value;
      this.handleClickSearch();
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleCellClick(item, column) { 
      if (this.editingId === item.id) { return ; }
      this.calcelEditing();
      if (column.property !== "code") { return; }
      this.editingId = item.id;
      this.oldItem = this.util.clone(item);
    },
    handleEnterCode(item) {
      if (this.oldItem.code === item.code) {
        this.calcelEditing();
        return;
      }
      let data = { id: item.id, code: item.code };
      this.api.replaceSerial(data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.editingId = -1;
      });
    },
    handleClickPrint() {
      this.dialog_visible = true;
    },
    handleCompletedPrint() {
      this.dialog_visible = false;
    },
  },
}
</script>